/**
 * useBackofficeCredits
 * Fetches and manages list of credits from /backoffice/credits
 */
import { useQuery } from '@tanstack/react-query';
import { listCredits } from '@/services/credit-engine.service';
import { PARTNER_ID } from '@/constants';

export function useBackofficeCredits() {
  const query = useQuery({
    queryKey: ['backoffice', 'credits', PARTNER_ID],
    queryFn: () => listCredits(PARTNER_ID),
  });

  return {
    credits: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
